import {initializeMediaUpload} from "./utility/media-uploader";
import {initializeFormSubmission} from "./utility/form-submission";
import {generateProductSlug} from "./utility/helper"; // Import the form submission function

document.addEventListener('DOMContentLoaded', function () {
    let uploadButton: HTMLElement | null;

    const AmbiklyProduct = {
        init: function () {
            this.handleMediaUpload();
            initializeFormSubmission(); // Call the imported form submission function
            this.bindSlugEvent();
            this.initLib();
        },
        handleMediaUpload: function () {
            const uploadButtons = document.querySelectorAll('.ambikly-image-upload');
            (uploadButtons as NodeListOf<HTMLElement>).forEach((button) => {
                button.addEventListener('click', (e: MouseEvent) => {
                    e.preventDefault();
                    uploadButton = e.currentTarget as HTMLElement;
                    initializeMediaUpload(uploadButton);
                });
            });
        },
        bindSlugEvent: function () {
            const productNameInput = document.querySelector('input[name="product_name"]') as HTMLInputElement;
            const productSlugInput = document.querySelector('input[name="product_slug"]') as HTMLInputElement;
            if (productNameInput) {
                productNameInput.addEventListener('input', () => {
                    const productName = productNameInput.value;
                    const slug = generateProductSlug(productName);
                    if (productSlugInput) {
                        productSlugInput.value = slug; // Set slug in product_slug input
                    }
                });
            }

        },

        initLib: function () {
            // Ignoring type errors for Select2
            // @ts-ignore
            if (typeof jQuery.fn.select2 !== 'undefined') {
                const multiselectElements = document.querySelectorAll('.ambikly-multiselect');
                multiselectElements.forEach(element => {
                    // Ignoring type errors for Select2
                    // @ts-ignore
                    jQuery(element).select2({}); // Use jQuery here if necessary for select2
                });
            }
        }

    };

    AmbiklyProduct.init();
});
